import React from 'react'

import { Button, CloseIcon } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import { OVERLAY } from 'components/AuthModal/styles'

import ticketImage from '../images/ticket-detail.svg'

const TicketDetailsModal = ({ onClose, event, show, user }) => (
  <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true}>
    <Modal innerClassName="overflow-y-scroll flex flex-col rounded-t-3xl overflow-hidden md:rounded-xl">
      <div className="relative flex flex-col text-white items-stretch justify-between h-full w-full p-4 bg-black md:p-6 md:px-7 md:w-108 md:max-h-screen">
        <div className="mb-4 md:mb-9">
          <div className="flex items-center justify-between mb-2">
            <div className="text-xl font-semibold font-ownersWide w-3/4 md:text-2xl">
              {event.title}
            </div>
            <button
              className="bg-white bg-opacity-20 w-6 h-6 rounded-full flex items-center justify-center"
              onClick={() => onClose()}
            >
              <CloseIcon className="w-2 h-2 text-white" />
            </button>
          </div>
          <div className="text-base opacity-50 mb-10">Present your ticket for expedited entry</div>
          <div className="flex flex-col items-center w-full">
            <div
              className="w-36 rounded-2xl relative overflow-hidden bg-codGrayLighter md:w-48"
              style={{
                filter: 'drop-shadow(0px 4px 65px rgba(236, 159, 74, 0.35))',
              }}
            >
              <img className="w-full" src={user.qrCodeURL} alt="qr code" />
              <div className="w-full pb-7">
                <div className="text-sm text-center px-4 py-3 border-0 border-b-2 border-dashed border-white border-opacity-10">
                  <span className="opacity-50">{user.name}</span>
                </div>
                <div className="px-4 pt-3">
                  <div className="p-4 bg-white rounded-md bg-opacity-5">
                    <img className="w-full" src={ticketImage} alt="ticket" />
                  </div>
                </div>
              </div>
              <div
                className="absolute z-10 bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-8 h-8 rounded-full"
                style={{
                  backgroundColor: 'rgba(236, 159, 74, 0.15)',
                  filter: 'drop-shadow(0px 9px 5px rgba(236, 159, 74, 0.35))',
                }}
              />
              <div className="absolute z-10 top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black opacity-90" />
            </div>
          </div>
        </div>
        <Button
          className="w-full border border-solid border-white border-opacity-30 text-lg"
          onClick={onClose}
        >
          ATTENDING
        </Button>
      </div>
    </Modal>
  </Overlay>
)

export default TicketDetailsModal
